import { PositionType } from '../../../lib/defs/types';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { waitAFrame } from '../../../lib/util/waitAFrame';
import { BeeCollectedAnimation } from '../../animations/BeeCollectedAnimation';
import { Container } from '../../../odie';

export type BeeGoalEffectOptions = {
  origin: Container;
  position: PositionType;
};

export class BeeGoalEffect implements IEffect {
  constructor(
    private scene: GameScene,
    private options: BeeGoalEffectOptions,
  ) {}

  public static assets(): string[] {
    return [];
  }

  public async execute() {
    // wait a frame since we async the animation
    await waitAFrame();

    // animate
    await this.animate();
  }

  private async animate() {
    // create  animation
    const animation = new BeeCollectedAnimation({
      origin: this.options.origin,
    });
    // spawn animation as overlay
    const entity = spawnOverlayEntity(
      this.scene,
      this.options.position,
      {},
      () => animation,
    );
    // run animation - don't await on purpose, so the grid can progress while animatiing
    void animation.start().then(() => {
      // despawn entity
      despawnOverlayEntity(this.scene, entity);
    });
  }
}
